import WithRender from "../../templates/containers/productPartsNamesContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getProductPartsNames",
      "getShowUpload",
      "getProductPartsOption",
      "getProductPartModeShow"
    ]),
    getPPMode: function () {
      return this.getProductPartModeShow;
    }
  },
  props: ["hideContainer"]
});
